import { motion } from "motion/react";
import type { ShowcasePanel } from "@/src/constants/product-showcase";

interface ShowcasePanelSplitProps {
    panel: ShowcasePanel;
    reverse?: boolean;
}

export function ShowcasePanelSplit({ panel, reverse }: ShowcasePanelSplitProps) {
    const image = (
        <div className="relative min-h-[50vh] lg:min-h-0">
            <motion.div
                initial={{ scale: 1.05 }}
                whileInView={{ scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 1.5 }}
                className="absolute inset-0"
            >
                <img
                    src={panel.image}
                    alt={panel.catchphrase}
                    className="w-full h-full object-cover"
                    referrerPolicy="no-referrer"
                />
            </motion.div>
        </div>
    );

    const text = (
        <motion.div
            initial={{ opacity: 0, x: reverse ? -24 : 24 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.2 }}
            className="flex items-center justify-center px-12 py-20 bg-stone-50"
        >
            <div className="max-w-sm">
                <h2 className="font-serif text-4xl font-light italic mb-6 leading-snug">
                    {panel.catchphrase}
                </h2>
                <p className="text-stone-600 font-light leading-relaxed text-sm">
                    {panel.body}
                </p>
            </div>
        </motion.div>
    );

    return (
        <div className="grid grid-cols-1 lg:grid-cols-2 lg:min-h-[70vh]">
            {reverse ? <>{text}{image}</> : <>{image}{text}</>}
        </div>
    );
}
